import { Modal } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface LeadWizardAbandonConfirmProps {
  open: boolean
  onOk: () => void
  onCancel: () => void
}

export function LeadWizardAbandonConfirm({
  open,
  onOk,
  onCancel
}: LeadWizardAbandonConfirmProps) {
  const { t } = useTranslation()

  return (
    <Modal
      centered
      open={open}
      title={t("leadWizard.abandon.title")}
      okText={t("leadWizard.abandon.ok")}
      cancelText={t("leadWizard.abandon.cancel")}
      onOk={onOk}
      onCancel={onCancel}
    >
      <p>{t("leadWizard.abandon.content")}</p>
    </Modal>
  )
}
